import axios from 'axios';
import { Detail } from './mycar-types';

function isErrorInterface(obj: any): boolean {
  try {
    // Основная логика проверки
    return (
      obj != null &&
      typeof obj === 'object' &&
      'code' in obj &&
      (obj.code === null || typeof obj.code === 'string') &&
      'message' in obj &&
      typeof obj.message === 'string'
    );
  } catch (error) {
    // Обработка непредвиденных ошибок
    console.error('Ошибка при проверке объекта:', error);
    return false; // Если что-то пошло не так, возвращаем false
  }
}

function tes() {
  console.log();
}

function isAxiosErr(error: unknown) {
  try {
    return axios.isAxiosError(error);
  } catch (e) {
    return false;
  }
}

function isBu(detail: Detail): boolean {
  if (!detail.attributes) {
    return false; // Если attributes отсутствуют
  }

  const attribute = detail.attributes.find((attr) => attr.name === 'IsBU');
  return attribute?.value === '1';
}

function isNewCar(detail: Detail): boolean {
  if (!detail.attributes) {
    return false; // Если attributes отсутствуют
  }

  const attribute = detail.attributes.find((attr) => attr.name === 'IsBU');
  return attribute?.value === '0';
}

export { isErrorInterface, isAxiosErr, isBu, isNewCar };
